import { Observable } from 'rxjs';

import {LoadingService} from '../services/loading.service';
import {finalize} from 'rxjs/operators';
import {OperatorFunction} from 'rxjs/internal/types';

export const LoadingServiceInstance = {
    instance: null,
    setService(loadingService: LoadingService) {
        this.instance = loadingService;
    },
    getService() {
        return this.instance;
    }
};

export function loadingWrap<T>(): OperatorFunction<T, T> {
  return (source: Observable<T>) => {
    return Observable.create((subscriber) => {
      const loadingService = LoadingServiceInstance.getService();
      loadingService.showLoading();
      return source.pipe(finalize(() => loadingService.hideLoading())).subscribe(subscriber);
    });
  };
}
